// extracted by mini-css-extract-plugin
export default {"video":"GuideVideo_video__Q5ZnQ","wrapper":"GuideVideo_wrapper__9ZDR3"};